<h2 class="mat-h2">Criteria across the productions</h2>

<div class="toolbar">
  <mat-form-field appearance="outline">
    <mat-label>State</mat-label>
    <mat-select [(ngModel)]="stateFilter" (ngModelChange)="rebuild()">
      <mat-option value="">All</mat-option>
      <mat-option *ngFor="let state of states" [value]="state">{{ stateLabels[state] }}</mat-option>
    </mat-select>
  </mat-form-field>

  <span class="muted">
    {{ games }} broadcast{{ games === 1 ? '' : 's' }}. The share is of the
    broadcasts where the criterion has a value; the small number is how many
    are still open.
  </span>
</div>

<div class="scroll" *ngIf="rows.length">
  <table class="grid">
    <thead>
      <tr>
        <th class="criterion">Criterion</th>
        <th *ngFor="let producer of producers; let i = index" class="share">
          {{ producer }}
          <span class="sub">{{ gamesPerProducer[i] }}</span>
        </th>
        <th class="share total">All<span class="sub">{{ games }}</span></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let row of rows">
        <tr class="group" *ngIf="row.groupStart">
          <td [attr.colspan]="producers.length + 2"><span>{{ row.groupStart }}</span></td>
        </tr>
        <tr>
          <td class="criterion">
            {{ row.criterion.label }}
            <span class="role" *ngIf="row.criterion.role === 'gate'"
                  matTooltip="Absolute condition — a miss pays nothing at all">gate</span>
            <span class="role" *ngIf="row.criterion.role === 'info'"
                  matTooltip="Measured and shown, but the contract does not pay for it">not paid</span>
            <span class="role" *ngIf="row.criterion.role === 'declared'"
                  matTooltip="Declared by the producer, confirmed by an admin">declared</span>
          </td>
          <td *ngFor="let cell of row.cells" class="share {{ tone(row.criterion, cell) }}"
              [matTooltip]="hint(cell)">
            <ng-container *ngIf="row.criterion.id === countCriterion; else asShare">
              {{ cell.total | number }}
            </ng-container>
            <ng-template #asShare>
              <span *ngIf="cell.share !== null">{{ cell.share * 100 | number:'1.0-0' }}%</span>
              <span *ngIf="cell.share === null" class="muted">—</span>
            </ng-template>
            <span class="open" *ngIf="cell.open">{{ cell.open }}</span>
          </td>
          <td class="share total {{ tone(row.criterion, row.all) }}" [matTooltip]="hint(row.all)">
            <ng-container *ngIf="row.criterion.id === countCriterion; else allAsShare">
              {{ row.all.total | number }}
            </ng-container>
            <ng-template #allAsShare>
              <span *ngIf="row.all.share !== null">{{ row.all.share * 100 | number:'1.0-0' }}%</span>
              <span *ngIf="row.all.share === null" class="muted">—</span>
            </ng-template>
            <span class="open" *ngIf="row.all.open">{{ row.all.open }}</span>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>

<p class="muted" *ngIf="!rows.length">Nothing published for this season yet.</p>
